exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1IFfubqrgRpwTp2O46l4ra{height:auto;min-height:120px}._2CRX9EsUqCnDBKsmWlX90t{padding:20px 20px}\n", ""]);

// Exports
exports.locals = {
	"hero": "_1IFfubqrgRpwTp2O46l4ra",
	"padded": "_2CRX9EsUqCnDBKsmWlX90t"
};